/**
 * Loaded before the app (angular.json `polyfills`).
 *
 * zone.js is no longer imported: jepto runs on zoneless change detection
 * (JEP-10521). The package itself is removed from the workspace in JEP-10524.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// Some dependencies still reference the Node `global` object.
(window as any).global = window;

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
